import comp from "./NoteV2";
export default comp;
